<template>
  <div>
      <secondHeader />
      <div class="discord-main">
        <sidebar />
        <main class="discord-content">
          <!-- Hero Section -->
          <section class="discord-hero">
            <div class="discord-hero-content">
              <h1 class="discord-hero-title">DiscordカスタムCSS</h1>
              <p class="discord-hero-description">Discordのオーバレイをカスタマイズできます</p>
            </div>
          </section>

          <!-- Streamkit Section -->
          <section class="discord-grid-section">
            <div class="discord-container">
              <h2 class="discord-section-title">Streamkitで使える</h2>
              <div class="discord-grid">
                <div @click="openModal('talkroom')" class="discord-card">
                  <div class="discord-preview-area">
                    <img :src="carousel[0].src" class="discord-preview-img" alt="きゅーとデザイン">
                  </div>
                  <div class="discord-card-content">
                    <h3 class="discord-card-title">きゅーと</h3>
                    <div class="discord-tags">
                      <span class="discord-tag">Streamkit</span>
                      <span class="discord-tag">サイズ変更</span>
                      <span class="discord-tag">形状変更</span>
                      <span class="discord-tag">アニメーション変更</span>
                      <span class="discord-tag">色変更</span>
                    </div>
                  </div>
                </div>
                <div @click="openModal('talkroom2')" class="discord-card">
                  <div class="discord-preview-area">
                    <img :src="carousel[1].src" class="discord-preview-img" alt="くらしっくデザイン">
                  </div>
                  <div class="discord-card-content">
                    <h3 class="discord-card-title">くらしっく</h3>
                    <div class="discord-tags">
                      <span class="discord-tag">Streamkit</span>
                      <span class="discord-tag">色変更</span>
                    </div>
                  </div>
                </div>
                <div @click="openModal('talkroom3')" class="discord-card">
                  <div class="discord-preview-area">
                    <img :src="carousel[2].src" class="discord-preview-img" alt="ひょっこりデザイン">
                  </div>
                  <div class="discord-card-content">
                    <h3 class="discord-card-title">ひょっこり</h3>
                  </div>
                  <div class="discord-tags">
                    <span class="discord-tag">Streamkit</span>
                    <span class="discord-tag">色変更</span>
                  </div>
                </div>
                <div @click="openModal('talkroom4')" class="discord-card">
                  <div class="discord-preview-area">
                    <img :src="carousel[3].src" class="discord-preview-img" alt="ゆめみみデザイン">
                  </div>
                  <div class="discord-card-content">
                    <h3 class="discord-card-title">ゆめみみ</h3>
                    <div class="discord-tags">
                      <span class="discord-tag">Streamkit</span>
                      <span class="discord-tag">色変更</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Discord Reactive Section -->
          <section class="discord-grid-section">
            <div class="discord-container">
              <h2 class="discord-section-title">Discord Reactiveで使える</h2>
              <div class="discord-grid discord-grid-single">
                <div @click="openModal('discordTech')" class="discord-card">
                  <div class="discord-premium-badge">Tech</div>
                  <div class="discord-preview-area">
                    <img :src="carousel[0].src" class="discord-preview-img" alt="きゅーとテック">
                  </div>
                  <div class="discord-card-content">
                    <h3 class="discord-card-title">きゅーと</h3>
                    <div class="discord-tags">
                      <span class="discord-tag">Discord Reactive</span>
                      <span class="discord-tag">形状変更</span>
                      <span class="discord-tag">アニメーション変更</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- モーダルの表示 -->
          <div v-if="showModal" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
              <span class="close" @click="closeModal">&times;</span>
              <component :is="currentComponent" />
            </div>
          </div>

          <!-- Ad Section -->
          <section class="discord-ad-block">
            <div class="discord-container">
              <div class="discord-ad">
                <InFeedAdsense
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-9016794589237931"
                    data-ad-slot="4898735474">
                </InFeedAdsense>
              </div>
            </div>
          </section>

          <!-- Blog Section -->
          <section class="discord-blog-area">
            <div class="discord-blog-content">
              <h2 class="discord-blog-title">使い方はブログでチェック！</h2>
              <div class="discord-blog-row">
                <div class="discord-blog-thumb">
                  <img src="@/assets/article/thombnail-discord.png" alt="DiscordカスタムCSSガイド">
                </div>
                <div>
                  <p class="discord-blog-desc">具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                  <div class="discord-blog-btn">
                    <a href="https://www.ruri.info/obs-discord-css/" target="_blank" rel="noopener noreferrer" class="discord-check-btn">記事をチェック</a>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import noticeBar from "../components/notice-bar.vue"
import sidebar from "../components/sidebar.vue"
import talkroom from "../components/discord/discordTalkroom.vue"
import talkroom2 from "../components/discord/discordTalkroom2.vue"
import talkroom3 from "../components/discord/discordTalkroom3.vue"
import talkroom4 from "../components/discord/discordTalkroom4.vue"
import discordTech from "../components/discord/discordTech.vue"

export default{
  components:{
      secondHeader,
      sidebar,
      noticeBar,
      talkroom,
      talkroom2,
      talkroom3,
      talkroom4,
      discordTech,
  },
  data(){
    return{
      isProduction: process.env.NODE_ENV === "production",
      showModal: false,
      currentComponent: null,
      carousel:[
        {
          index: 1,
          src: require("@/assets/carousel/discord-design1.png")
        },
        {
          index: 2,
          src: require("@/assets/carousel/discord-design2.png")
        },
        {
          index: 3,
          src: require("@/assets/carousel/discord-design3.png")
        },
        {
          index: 4,
          src: require("@/assets/carousel/discord-design4.png")
        },
        {
          index: 5,
          src: require("@/assets/carousel/new_type.png"),
          title: "準備中"
        },
      ]
    }
  },
  methods: {
    openModal(componentName) {
      this.currentComponent = componentName;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

/* Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Layout */
.discord-main {
  min-height: 100vh;
  display: flex;
}

.discord-content {
  flex: 1;
  background: #fafafa;
  padding: 0 16px;
  overflow-x: hidden;
}

/* Container */
.discord-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.discord-hero {
  background: white;
  padding: 48px 0;
}

.discord-hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}

.discord-hero-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
  margin-bottom: 16px;
}

.discord-hero-description {
  font-size: 1.125rem;
  color: #64748b;
  line-height: 1.6;
}

/* Discord Grid Section */
.discord-grid-section {
  background: white;
  padding: 32px 0;
}

.discord-section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 24px;
  text-align: center;
  letter-spacing: -0.025em;
}

.discord-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.discord-grid-single {
  grid-template-columns: repeat(2, 1fr);
  justify-items: start;
}

.discord-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
  overflow: hidden;
  width: 100%;
}

.discord-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.discord-premium-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  z-index: 2;
}

.discord-preview-area {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
}

.discord-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.discord-card-content {
  text-align: left;
}

.discord-card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
  line-height: 1.4;
}

.discord-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.discord-tag {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 4px 8px;
  border-radius: 6px;
  letter-spacing: 0.25px;
}

/* Modal */
.modal {
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 2vh auto;
  padding: 32px;
  border: none;
  border-radius: 16px;
  width: 90%;
  max-width: 1000px;
  min-height: 85vh;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.close {
  color: #64748b;
  float: right;
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
  transition: color 0.2s ease;
}

.close:hover,
.close:focus {
  color: #0f172a;
  text-decoration: none;
  cursor: pointer;
}

/* Ad Section */
.discord-ad-block {
  background: #f8fafc;
  padding: 48px 0;
  text-align: center;
}

.discord-ad {
  max-width: 70%;
  margin: 0 auto;
  display: block;
}

/* Blog Area */
.discord-blog-area {
  background: white;
  padding: 48px 0;
  border-top: 1px solid #e2e8f0;
}

.discord-blog-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px;
}

.discord-blog-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #0f172a;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: -0.025em;
}

.discord-blog-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
}

.discord-blog-thumb img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.discord-blog-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
  margin-bottom: 24px;
}

.discord-blog-btn .discord-check-btn {
  display: inline-block;
  background: #0f172a;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.discord-blog-btn .discord-check-btn:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 1024px) {
  .discord-grid {
    gap: 20px;
  }
  
  .discord-container {
    padding: 0 20px;
  }
}

@media (max-width: 768px) {
  .discord-hero {
    padding: 32px 0;
  }
  
  .discord-hero-title {
    font-size: 1.875rem;
  }
  
  .discord-hero-description {
    font-size: 1rem;
  }
  
  .discord-grid-section {
    padding: 48px 0;
  }
  
  .discord-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .discord-grid-single {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  
  .discord-card {
    padding: 16px;
  }
  
  .discord-preview-area {
    height: 160px;
    margin-bottom: 12px;
  }
  
  .discord-container {
    padding: 0 16px;
  }
  
  .discord-content {
    padding: 0 8px;
  }
  
  .discord-blog-row {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .modal-content {
    width: 95%;
    padding: 24px;
    margin: 5vh auto;
  }
}

@media (max-width: 480px) {
  .discord-hero-title {
    font-size: 1.5rem;
  }
  
  .discord-hero-description {
    font-size: 0.875rem;
  }
  
  .discord-grid {
    gap: 12px;
  }
  
  .discord-grid-single {
    justify-items: center;
  }
  
  .discord-preview-area {
    height: 140px;
  }
  
  .discord-container {
    padding: 0 12px;
  }
  
  .discord-content {
    padding: 0 4px;
  }
  
  .discord-card-title {
    font-size: 1rem;
  }
  
  .modal-content {
    width: 98%;
    padding: 16px;
    margin: 2vh auto;
    min-height: 90vh;
  }
}
</style>